import React from 'react';

const TaxonomyFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.3327 3.3999H2.66602L8.53268 10.3372V15.1332L11.466 16.5999V10.3372L17.3327 3.3999Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TaxonomyFilterIcon;
